import {createAction} from "redux-act";
import {
	IFetchTeamsResponse,
	IPlayerActionsPayload,
	IShareImageResponse,
	IWithLanguage,
	Lineup,
} from "modules/types";
import {PlayerPositionEnum} from "modules/enums";

export const addPlayerToTeam = createAction<IPlayerActionsPayload>();
export const removePlayerFromTeam = createAction<PlayerPositionEnum>();
export const clearAllPlayers = createAction();

export const fetchUserTeams = createAction<boolean>();
export const fetchUserTeamsSuccess = createAction<IFetchTeamsResponse>();
export const fetchUserTeamsFailed = createAction();

export const saveUserTeamRequest = createAction();
export const saveUserTeamSuccess = createAction<IFetchTeamsResponse>();
export const saveUserTeamClear = createAction();

export const setTeamChanged = createAction();

export const fetchTeamSharingImage = createAction<IWithLanguage<number>>();
export const fetchSharingImageSuccess = createAction<IShareImageResponse>();
export const fetchSharingImageClear = createAction();
export const sharingImageLoaded = createAction<boolean>();

export const fetchFavVoteSharingImage = createAction<IWithLanguage<number>>();
export const fetchFavVoteSharingImageSuccess = createAction<string>();
export const fetchFavVoteSharingImageFailed = createAction();

export const setLineup = createAction<Lineup>();

export const continueFetchData = createAction();
